import script from "./FaceAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceAuth.vue?vue&type=script&setup=true&lang=js"

import "./FaceAuth.vue?vue&type=style&index=0&id=31a97a49&lang=css"

const __exports__ = script;

export default __exports__